/**
 * Brings settings and scores across from the old name.
 *
 * Everything anybody had was filed under aurea.*: their calibration, their best runs, the ghost
 * they race, the session that signs them in. Renaming the keys without moving what is behind
 * them would have read as the app forgetting them, which is a bad way to meet a new name.
 *
 * Copied rather than moved, and only where nothing is already there, so running twice is
 * harmless and anybody still on the old build keeps working.
 */

const WAS = "aurea.";
const IS = "dodobop.";

export function carryOver(): void {
  try {
    const older: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== null && key.startsWith(WAS)) older.push(key);
    }
    for (const key of older) {
      const now = IS + key.slice(WAS.length);
      if (localStorage.getItem(now) !== null) continue;
      const held = localStorage.getItem(key);
      if (held !== null) localStorage.setItem(now, held);
    }
  } catch {
    // Private mode, or a full store. Starting fresh is worse than crashing is not.
  }
}
